export const LogsTable = ({ expandedLogs, userId, capitalize }) => {
  const logs = expandedLogs[userId]?.logs || [];

  return (
    <tr className="logs-row">
      <td colSpan={13} className="logs-table-td">
        {logs.length === 0 ? (
          <p style={{ textAlign: "left", fontSize: "small", border: "none" }}>
            No logs available
          </p>
        ) : (
          <table className="data-table logs-table-responsive"style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>Action</th>
                <th>By</th>
                <th>Email</th>
                <th>Timestamp</th>
                <th colSpan={5}>Changes</th>
              </tr>
            </thead>

            <tbody>
              {logs.map((log) => {
                let prevArray = [];
                let newArray = [];

                try {
                  prevArray = JSON.parse(log.previous_data || "[]");
                  newArray = JSON.parse(log.new_data || "[]");
                } catch (e) {
                  console.error("Error parsing logs", e);
                }

                return newArray.map((newData, i) => {
                  const previousData = prevArray[i] || {};

                  return (
                    <tr key={`${log.id}-${i}`}>
                      <td data-label="Action">
                        {capitalize(log.action_type)}
                      </td>

                      <td data-label="By">{log.name}</td>

                      <td data-label="Email">{log.email}</td>

                      <td data-label="Timestamp">
                        {new Date(log.log_timestamp).toLocaleString(undefined, {
                          weekday: "short",
                          year: "numeric",
                          month: "short",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </td>

                      <td data-label="Changes" colSpan={5}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                          {Object.keys(newData).map((key) => (
                            <div key={key}>
                              <strong>{key}:</strong> "{previousData[key] ?? "—"}" → "
                              {newData[key] ?? "—"}"
                            </div>
                          ))}
                        </div>
                      </td>
                    </tr>
                  );
                });
              })}
            </tbody>
          </table>
        )}
      </td>
    </tr>
  );
};
